export default {"src":"/_next/static/media/ic-add-gray.a133f2a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};